export default __webpack_public_path__ + "static/media/done-black.071d6faa.svg";